import React from 'react';

const colors = {
  AMD: '#fc6522',
  Intel: '#0071c5',
  NVIDIA: '#76b900',
  RYZEN: '#bd0000',
  default: '#949494',
};

const getCpuColor = (cpu) => {
  if (cpu?.toLowerCase() === 'intel' || cpu?.toLowerCase().startsWith('intel'))
    return colors.Intel;
  if (cpu?.toLowerCase() === 'amd' || cpu?.toLowerCase().startsWith('amd'))
    return colors.AMD;
  return colors.default;
};
const getGpuColor = (gpu) => {
  const regexRTX = /\bRTX\b/i;
  const regexRX = /\bRX\b/i;
  if (regexRTX.test(gpu) || gpu?.toLowerCase().startsWith('nvidia'))
    return colors.NVIDIA;
  if (regexRX.test(gpu) || gpu?.toLowerCase().startsWith('amd'))
    return colors.RYZEN;
  return colors.default;
};

const SubHeader = ({ tags, title }) => {
  const preparedTitle = title.split('/')[1].trim().split(' + ');
  const cpuColor = getCpuColor(tags.CPU);
  const gpuColor = getGpuColor(
    tags['Graphics-card'] ? tags['Graphics-card'] : tags['graphics-card'],
  );

  return (
    <>
      <span style={{ color: cpuColor }}>{preparedTitle[0]}</span>
      {tags['Graphics-card'] !== 'intergrated' &&
        tags['Graphics-card'] !== 'Intel Graphics' &&
        !tags['Graphics-card']?.toLowerCase().includes('integrated') && (
          <>
            <span style={{ color: 'white' }}>{' + '}</span>
            <span style={{ color: gpuColor }}>{preparedTitle[1]}</span>
          </>
        )}
    </>
  );
};

export default SubHeader;
